var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconViewpricetracker = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 3C16.968 3 21 7.032 21 12C21 16.968 16.968 21 12 21C7.032 21 3 16.968 3 12C3 7.032 7.032 3 12 3ZM12 4.5C7.85625 4.5 4.5 7.85625 4.5 12C4.5 16.1438 7.85625 19.5 12 19.5C16.1438 19.5 19.5 16.1438 19.5 12C19.5 7.85625 16.1438 4.5 12 4.5Z",
  fill: "#7F7F7F"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.75 11.25H23V12.75H12.75V23H11.25V12.75H1V11.25H11.25V1H12.75V11.25Z",
  fill: "#7F7F7F"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconViewpricetracker);
export { ForwardRef as ReactComponent };